module.exports = __webpack_public_path__ + "static/fonts/iconfont.173e175e.woff2";